import React from 'react';

const CardiogramTooltip = () => {
    return (
        <>
            <ul className="tooltip-contents">
                <li>
                    <em className="tit">허가번호</em>
                    <span className="desc">제인 21-4840호</span>
                </li>
                <li>
                    <em className="tit">품목명</em>
                    <span className="desc">홀터심전계​​</span>
                </li>
                <li>
                    <em className="tit">모델명</em>
                    <span className="desc">mobiCARE-MC200M</span>
                </li>
                <li>
                    <em className="tit">제조업자</em>
                    <span className="desc">(주)씨어스테크놀로지</span>
                </li>
                <li>
                    <em className="tit">의료기기 표준코드(UDI)</em>
                    <span className="desc">08800096400805</span>
                </li>
            </ul>
            <p className="notice">
                <span>
                    본 제품은 "의료기기"입니다.
                </span>
            </p>
        </>
    )
}

export default CardiogramTooltip
